/**
 * Ticket view-mode preference — backward-compatible "переключалка" between the
 * classic single-ticket page (`/tickets/:id`) and the new messenger-style
 * Workspace (`/work/:id`) with the left rail of active tickets.
 *
 * The classic page stays the default so nothing changes for anyone who doesn't
 * opt in. The choice is remembered per-browser in localStorage, and the helper
 * `ticketHref()` lets the tickets list route a row click to whichever view the
 * operator picked — without forking the list code.
 */
export type TicketViewMode = 'classic' | 'workspace';

const KEY = 'ggdesk:ticketViewMode';

export function getTicketViewMode(): TicketViewMode {
  try {
    return localStorage.getItem(KEY) === 'workspace' ? 'workspace' : 'classic';
  } catch {
    return 'classic';
  }
}

export function setTicketViewMode(mode: TicketViewMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* private mode / storage disabled — fall back to classic silently */
  }
}

/** Path to open a given ticket in the operator's currently-preferred view. */
export function ticketHref(id: string): string {
  return getTicketViewMode() === 'workspace' ? `/work/${id}` : `/tickets/${id}`;
}
